import React from 'react'
import { api } from 'src/api/root'
import { cn } from 'src/enviroment/lib/utils'
import { IconEye, IconEyeOff } from '@tabler/icons-react'

interface VisibilityToggleProps {
  id: string
  isVisible: boolean // This should be globallyVisibleStatus from parent
}

const VisibilityToggle: React.FC<VisibilityToggleProps> = ({ id, isVisible }) => {
  const { mutate: toggleVisibility, isPending } = api.layer.toggleVisibility.useMutation()

  const handleToggle = () => {
    toggleVisibility({ fileId: id, visible: !isVisible })
  }

  return (
    <button
      onClick={handleToggle}
      disabled={isPending}
      className={cn(
        'transition-colors disabled:opacity-50',
        isVisible ? 'text-light-green-500 hover:text-light-green-400' : 'text-gray-400 hover:text-gray-300',
        'flex h-11 w-11 items-center justify-center rounded-[8px] hover:cursor-pointer active:scale-95',
      )}
      title={isVisible ? 'Hide layer' : 'Show layer'}
    >
      {isVisible ? <IconEye size={24} /> : <IconEyeOff size={24} />}
    </button>
  )
}

export default VisibilityToggle
